import React from 'react'

const XIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
       style={props.style}
       className={`icon--social icon--social-twitter ${props.className || ''}`}
       viewBox='0 0 21 20'
  >
    <path d='M12.1,8.7l6.2-7.1h-1.5l-5.4,6.1L7.1,1.7h-5l6.5,9.3l-6.5,7.4h1.5l5.7-6.5l4.5,6.5h5 M4.2,2.8h2.3l10.4,14.5h-2.3' />

  </svg>
)

export default XIcon
